module.exports = __webpack_public_path__ + "static/media/Hoist_ios_3.cc65ec82.jpg";